module.exports = __webpack_public_path__ + "assets/img/a.ca3eb3d8.png";